export const SET_CART_DATA = 'SET_CART_DATA';

export const SET_CART_DATA_REQUEST ="SET_CART_DATA_REQUEST";
export const SET_CART_DATA_SUCCESS ="SET_CART_DATA_SUCCESS";
export const SET_CART_DATA_FAILURE ="SET_CART_DATA_FAILURE";
